export type TestimonialCard = {
  id: string;
  heading: string;
  thumbnailSrc: string;
  thumbnailAlt: string;
  thumbnailPosition?: string;
  youtubeVideoId: string;
  /** Force captions on in this language (auto-translated by YouTube when needed). */
  captionsLang?: string;
};

export const testimonialsContent = {
  pretitle: 'Testimonials',
  heading: 'Hear from our partners and learners',
};

export const testimonialsItems: TestimonialCard[] = [
  {
    id: 'fwd-scholarship-egypt',
    heading: 'Egypt FWD Scholarship - Ministry of Communications and Information Technology',
    thumbnailSrc: '/images/government/testimonials/fwd-scholarship-egypt.jpg',
    thumbnailAlt: 'FWD scholarship participant in Egypt',
    youtubeVideoId: '2vWcPq0TVg4',
  },
  {
    id: 'simon-risberg',
    heading: 'Simon Risberg - Udacity Google Scholarship Graduate',
    thumbnailSrc: '/images/government/testimonials/simon-risberg.jpg',
    thumbnailAlt: 'Simon Risberg, Udacity scholarship graduate',
    youtubeVideoId: 'E9o3ykUYQX4',
  },
  {
    id: 'empowering-emirati-youth',
    heading: 'Empowering Emirati youth',
    thumbnailSrc: '/images/government/testimonials/empowering-emirati-youth.jpg',
    thumbnailAlt: 'Empowering Emirati youth',
    youtubeVideoId: 'vDiemnJCvqA',
  },
  {
    id: 'jason-front-end',
    heading: 'Jason’s journey to front-end web development',
    thumbnailSrc: '/images/government/testimonials/jason-front-end-journey.jpg',
    thumbnailAlt: 'Jason’s journey to front-end web development',
    thumbnailPosition: 'center',
    youtubeVideoId: 'AXV1cQzsz2o',
  },
  {
    id: 'middle-east-talent-ecosystem',
    heading: 'Building a future-proof talent ecosystem in the Middle East',
    thumbnailSrc: '/images/government/testimonials/middle-east-talent-ecosystem.jpg',
    thumbnailAlt: 'Workforce development in the Middle East',
    thumbnailPosition: 'center bottom',
    youtubeVideoId: 'gAqLcjPOacQ',
  },
  {
    id: 'bsf-graduation',
    heading: 'BSF Scholarship Program in Saudi Arabia',
    thumbnailSrc: '/images/government/testimonials/banque-saudi-fransi-graduation-v2.jpg',
    thumbnailAlt: 'BSF scholarship program participant in Saudi Arabia',
    thumbnailPosition: 'center top',
    youtubeVideoId: 'EQp9iq0_QcA',
    captionsLang: 'en',
  },
];
